"use client";

import type { DetailedListing } from "@repo/database";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const LISTINGS_UTM_CONTENT_KEY = "venturu_listingsUTMContent";

export type ListingUTMContentTrackerProps = {
  listing: DetailedListing;
};

export type ListingUTMSourceMap = {
  [listingId: number]: string[];
};

export function ListingUTMContentTracker({
  listing,
}: ListingUTMContentTrackerProps) {
  const searchParams = useSearchParams();

  useEffect(() => {
    const utmContent = searchParams.get("utm_content");
    if (!utmContent) {
      return;
    }

    let mapToSet: ListingUTMSourceMap = {};

    const current = localStorage.getItem(LISTINGS_UTM_CONTENT_KEY);

    if (current) {
      try {
        const parsedMap = JSON.parse(current);
        if (typeof parsedMap === "object" && parsedMap !== null) {
          mapToSet = parsedMap;
        }
      } catch (err) {
        console.error("Error parsing UTM content map from localStorage", err);
      }
    }

    if (mapToSet[listing.id]) {
      if (mapToSet[listing.id].includes(utmContent)) {
        return;
      }

      mapToSet[listing.id].push(utmContent);
    } else {
      mapToSet[listing.id] = [utmContent];
    }

    localStorage.setItem(LISTINGS_UTM_CONTENT_KEY, JSON.stringify(mapToSet));
  }, [searchParams]);

  return null;
}
